import { Pipe, PipeTransform } from '@angular/core';
import { EntidadeService } from '../modules/basico/entidade/entidade.service';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Pipe({
  name: 'imageEntidade'
})
export class ImageEntidadePipe implements PipeTransform {

  constructor(
    private service: EntidadeService,
  ){}

  transform(value: any, args?: any): any {
    return this.service.getImagem(value);
  }

}
